module.exports = __webpack_public_path__ + "img/ref.039f930c.svg";